import React, { useEffect, useRef, useState } from "react";
import BtnEdit from "./btn-edit";
import BtnCancel from "./btn-cancel";
import BtnSave from "./btn-save";
import imgWarning from "../../../assets/siteManagement/images/warning-2.svg";
import ItemCard from "./building-info-item-card";
import ItemCardNew from "./building-info-item-card-new";
import PopupModalConfirmSave from "../popup-modal/confirm-save";
import {
  addBuilding,
  deleteBuilding,
  editBuilding,
  getBuildingBySiteId,
} from "../../../api/site";
import area from "../../../assets/images/area.jpg";
import { useTranslation } from 'react-i18next'

function BuildingContent(props) {
  const [siteId, setSiteId] = useState(null);
  const [disable, setDisable] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [isOpenPopupConFirmSave, setIsOpenPopupConFirmSave] = useState(false);
  const [isClearValueItemCardNew, setIsClearValueItemCardNew] = useState(false);
  const [isClearValueAreaCardNew, setIsClearValueAreaCardNew] = useState(false);
  const [listItemInfo, setListItemInfo] = useState([]);
  const [listAreaInfo, setListAreaInfo] = useState([]);
  const listItemInfoDefaultRef = useRef([]);
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);
  const [tab, setTab] = useState("Building information");
  const handleTabsChange = (tab) => {
    setTab(tab);
  };
  const { t } = useTranslation("settings");


  //==============================
  useEffect(() => {
    setDisable(props.disable ? props.disable : false);
  }, [props.disable]);
  useEffect(() => {
    if (props.siteId) {
      setSiteId(props.siteId);
    }
  }, [props.siteId]);
  useEffect(() => {
    if (siteId) {
      onGetItemInfo(siteId);
    }
  }, [siteId]);
  //==============================
  function randomString(length) {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  async function onGetItemInfo(param) {
    listItemInfoDefaultRef.current = [];
    let listX = [];
    const response = await getBuildingBySiteId(param);
    if (response.status) {
      let dataResponse = response.data;
      for (let item of dataResponse?.building) {
        let listSubArea = [];
        if (Array.isArray(item.floor)) {
          listSubArea = item.floor;
        }
        const detail = {
          Id: item.building_id,
          Name: item.building_name,
          SubDetail: `${listSubArea.length} ${t('site_management.floor')}`,
          Sequence: item.building_sequence,
        };
        listX.push(detail);
      }
      listX.sort((a, b) => (a.Sequence > b.Sequence ? 1 : -1));
    }
    listItemInfoDefaultRef.current = listX.slice();
    setListItemInfo(listX);
  }
  function onSortFromDrag() {
    let listX = listItemInfo.slice();
    const dragItemX = listX.splice(dragItem.current, 1)[0];
    listX.splice(dragOverItem.current, 0, dragItemX);
    dragItem.current = null;
    dragOverItem.current = null;
    setListItemInfo(listX);
  }
  //==============================
  function onDragStartItem(param) {
    dragItem.current = param;
  }
  function onDragEnterItem(param) {
    dragOverItem.current = param;
  }
  function onDragOverItem(param) {
    param.preventDefault();
  }
  //==============================
  function onClickEdit() {
    setIsEdit(true);
  }
  function onClickCancel() {
    setListItemInfo([]);
    setTimeout(() => {
      let listX = listItemInfoDefaultRef.current.slice();
      setListItemInfo(listX);
    }, 1);
    setIsEdit(false);
  }
  async function onClickSave() {
    setIsOpenPopupConFirmSave(true);
  }
  async function onConfirmSave() {
    setIsOpenPopupConFirmSave(false);
    //==============================
    for (let item of listItemInfoDefaultRef.current) {
      let model = listItemInfo.find((x) => x.Id === item.Id);
      if (!model) {
        const response = await deleteBuilding(item.Id);
      }
    }
    //==============================
    for (let [index, item] of listItemInfo.entries()) {
      if (item.NewItem) {
        const body = {
          name: item.Name,
          plant: siteId,
          sequence: index,
        };
        const response = await addBuilding(body);
      } else {
        let model = listItemInfoDefaultRef.current.find(
          (x) =>
            x.Id === item.Id && x.Name === item.Name && x.Sequence === index
        );
        if (!model) {
          const body = {
            name: item.Name,
            plant: siteId,
            sequence: index,
          };
          const response = await editBuilding(item.Id, body);
        }
      }
    }
    await onGetItemInfo(siteId);
    setIsEdit(false);
  }
  function onClickItemCard(param) {
    try {
      props.onSelectItem(param);
    } catch {}
  }
  function onDeleteItemCard(param) {
    let listX = listItemInfo.slice();
    listX = listX.filter((x) => x.Id !== param.Id);
    setListItemInfo(listX);
  }
  function onInputTextItemCard(param, text) {
    let listX = listItemInfo.slice();
    let model = listX.find((x) => x.Id === param.Id);
    if (model) {
      model.Name = text;
    }
    setListItemInfo(listX);
  }
  function onClickAddNewItemCard(param) {
    let listX = listItemInfo.slice();
    const detail = {
      Id: randomString(10),
      Name: param,
      SubDetail: ``,
      Sequence: ``,
      NewItem: true,
    };
    listX.push(detail);
    setListItemInfo(listX);
    //==============================
    setIsClearValueItemCardNew(true);
    setTimeout(() => {
      setIsClearValueItemCardNew(false);
    }, 1);
  }

  // add new area
  function onClickAddNewAreaItemCard(name, amount, unit) {
    let listX = listAreaInfo.slice();
    const detail = {
      Id: randomString(10),
      Name: name,
      amount: amount,
      unit: unit,
      SubDetail: ``,
      Sequence: ``,
      NewItem: true,
    };
    listX.push(detail);
    setListAreaInfo(listX);
    //==============================
    setIsClearValueAreaCardNew(true);
    setTimeout(() => {
      setIsClearValueAreaCardNew(false);
    }, 1);

    // Update selectedAreaDetails
    setSelectedAreaDetails(detail);
  }

  function onDeleteAreaCard(param) {
    let listX = listAreaInfo.slice();
    listX = listX.filter((x) => x.Id !== param.Id);
    setListAreaInfo(listX);
  }

  function onInputTextAreaCard(param, text) {
    let listX = listAreaInfo.slice();
    let model = listX.find((x) => x.Id === param.Id);
    if (model) {
      model.Name = text;
    }
    setListAreaInfo(listX);
  }

  function onSortAreaFromDrag() {
    let listX = listAreaInfo.slice();
    const dragItemX = listX.splice(dragItem.current, 1)[0];
    listX.splice(dragOverItem.current, 0, dragItemX);
    dragItem.current = null;
    dragOverItem.current = null;
    setListAreaInfo(listX);
  }

  //==============================

  const [selectedAreaDetails, setSelectedAreaDetails] = useState(null);
  const [isAreaDetailsPopupOpen, setIsAreaDetailsPopupOpen] = useState(false);
  const [isEditName, setIsEditName] = useState(false);
  const [editedName, setEditedName] = useState("");
  const [isEditAmount, setIsEditAmount] = useState(false);
  const [editedAmount, setEditedAmount] = useState("");
  const [originalName, setOriginalName] = useState("");
  const [originalAmount, setOriginalAmount] = useState("");
  const [editedUnit, setEditedUnit] = useState("");

  const [isEditDetail, setIsEditDetail] = useState(false);
  const [editedDetail, setEditedDetail] = useState("");
  const [originalDetail, setOriginalDetail] = useState("");

  const [isEditUnit, setIsEditUnit] = useState(false);
  const [originalUnit, setOriginalUnit] = useState("");

  function handleDetailBlur() {
    if (!editedDetail.trim()) {
      setEditedDetail(originalDetail);
    }
    setIsEditDetail(false);

    setSelectedAreaDetails((prevDetails) => ({
      ...prevDetails,
      detail: editedDetail.trim(),
    }));
  }

  function handleUnitBlur() {
    if (!editedUnit.trim()) {
      setEditedUnit(originalUnit);
    }
    setIsEditUnit(false);

    setSelectedAreaDetails((prevDetails) => ({
      ...prevDetails,
      unit: editedUnit.trim(),
    }));
  }

  function onClickAreaItemCard(areaDetails) {
    setSelectedAreaDetails(areaDetails);
    setIsAreaDetailsPopupOpen(true);
  }

  function onCloseAreaDetailsPopup() {
    setIsAreaDetailsPopupOpen(false);
  }

  function handleNameBlur() {
    if (!editedName.trim()) {
      setEditedName(originalName);
    }
    setIsEditName(false);

    setSelectedAreaDetails((prevDetails) => ({
      ...prevDetails,
      Name: editedName.trim(),
    }));
  }

  function handleAmountBlur() {
    if (!editedAmount.trim()) {
      setEditedAmount(originalAmount);
    }
    setIsEditAmount(false);

    setSelectedAreaDetails((prevDetails) => ({
      ...prevDetails,
      amount: editedAmount.trim(),
    }));
  }

  return (
    <div className="w-full h-full">
      {isOpenPopupConFirmSave && (
        <PopupModalConfirmSave
          isOpen={isOpenPopupConFirmSave}
          labelMain={`${t('site_management.confirm.save')}`}
          onClickConfirm={(e) => {onConfirmSave()}}
          onClickClose={(e) => { setIsOpenPopupConFirmSave(false)}}
        />
      )}
      <div className={`w-full h-[40px] mb-2  items-center ${isAreaDetailsPopupOpen && selectedAreaDetails ? "hidden" : "flex"}`}>
        <div className="flex items-center justify-between w-full gap-6">
          <button
            onClick={() => handleTabsChange("Building information")}
            type="button"
            role="tab"
            className={`w-full rounded-t-lg inline-flex items-center gap-2 px-4 py-2 -mb-px text-sm ${tab === "Building information"? "text-secondary font-bold": "text-secondary font-normal shadow-md"}`}>
            {t('site_management.building_info')}
          </button>
          <button
            onClick={() => handleTabsChange("Area information")}
            type="button"
            role="tab"
            className={`w-full rounded-t-lg inline-flex items-center gap-2 px-4 py-2 -mb-px text-sm ${ tab === "Area information"? "text-secondary font-bold": "text-secondary font-normal shadow-md"} `} >
            {t('site_management.area_info')}
          </button>
        </div>

        <div className="w-1/4 h-full ml-auto mr-0">
          {!isEdit ? (
            <BtnEdit
              text={`${t('site_management.edit')} `}
              disable={disable}
              onClick={(e) => { onClickEdit()}}
            />
          ) : (
            <div className="flex h-full">
              <div className="mr-2">
                <BtnCancel onClick={(e) => {onClickCancel()}}/>
              </div>
              <BtnSave onClick={(e) => { onClickSave()}}/>
            </div>
          )}
        </div>
      </div>

      {tab === "Building information" && (
        <div
          className="relative w-full"
          style={{ height: "calc(100% - 48px)" }}
        >
          {!isEdit && listItemInfo.length === 0 && (
            <div className="flex items-center justify-center w-full h-full">
              <div className="w-full">
                <div className="flex justify-center">
                  <img className="w-11 h-11" src={imgWarning} alt="" />
                </div>
                <div className="flex justify-center mt-2">
                  <p className={`text-tertiary text-xs font-medium`}>
                    {disable? `${t('site_management.save_site')}`: `${t('site_management.no_building')}`}
                  </p>
                </div>
              </div>
            </div>
          )}
          <div className="w-full h-full overflow-y-auto">
            {listItemInfo.map((value, index) => {
              return (
                <div
                  key={value.Id}
                  className="w-full h-12 mb-2"
                  draggable={isEdit}
                  onDragStart={(e) => {onDragStartItem(index)}}
                  onDragEnter={(e) => {onDragEnterItem(index)}}
                  onDragEnd={(e) => {onSortAreaFromDrag()}}
                  onDragOver={(e) => {onDragOverItem(e)}}
                >
                  <ItemCard
                    isEdit={isEdit}
                    detail={value}
                    mode={1}
                    placeholder={`${t('site_management.building_name')}`}
                    onClick={(e) => {onClickItemCard(value)}}
                    onDelete={(e) => {onDeleteItemCard(value)}}
                    onInputText={(e) => {onInputTextItemCard(value, e)}}
                  />
                </div>
              );
            })}
            {isEdit && (
              <div className="w-full h-12 mb-2">
                <ItemCardNew
                  placeholder={`+ ${t('site_management.add_building')}`}
                  clear={isClearValueItemCardNew}
                  onClickAdd={(e) => { onClickAddNewItemCard(e) }}
                />
              </div>
            )}
          </div>
        </div>
      )}

      {tab === "Area information" && (
        <div
          className={`w-full ${isAreaDetailsPopupOpen && selectedAreaDetails? "hidden" : "relative"}`}
          style={{ height: "calc(100% - 48px)" }}
        >
          {!isEdit && listAreaInfo.length === 0 ? (
            <div className="flex items-center justify-center w-full h-full">
              <div className="w-full">
                <div className="flex justify-center">
                  <img className="w-11 h-11" src={imgWarning} alt="Warning" />
                </div>
                <div className="flex justify-center mt-2">
                  <p className={`text-tertiary text-xs font-medium`}>
                    {disable? `${t('site_management.save_area')}`: `${t('site_management.no_area')}`}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="w-full h-full overflow-y-auto">
              {listAreaInfo.map((value, index) => (
                <div
                  key={value.Id}
                  className="w-full h-12 mb-2"
                  draggable={isEdit}
                  onDragStart={(e) => {onDragStartItem(index) }}
                  onDragEnter={(e) => {onDragEnterItem(index)}}
                  onDragEnd={(e) => { onSortFromDrag()}}
                  onDragOver={(e) => {onDragOverItem(e)}}
                >
                  <ItemCard
                    isEdit={isEdit}
                    detail={value}
                    mode={1}
                    placeholder={`${t('site_management.area_name')}`}
                    onClick={(e) => {onClickAreaItemCard(value)}}
                    onDelete={(e) => {onDeleteAreaCard(value)}}
                    onInputText={(e) => {onInputTextAreaCard(value, e)}}
                  />
                </div>
              ))}
              {isEdit && (
                <div className="w-full h-12 mb-2">
                  <ItemCardNew
                    placeholder={`+ ${t('site_management.add_area')}`}
                    clear={isClearValueAreaCardNew}
                    onClickAdd={(name) => {onClickAddNewAreaItemCard(name)}}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {isAreaDetailsPopupOpen && selectedAreaDetails && (
        <div className="flex flex-col justify-start w-full h-full duration-300 ease-in-out rounded-lg cursor-pointer hover:bg-vekin-greengray">
          <div className="flex items-center gap-2">
            <button onClick={onCloseAreaDetailsPopup}>
              <i className="ri-arrow-left-line text-vekin"></i>
            </button>
            {isEditName ? (
              <input
                type="text"
                value={editedName}
                onChange={(e) => setEditedName(e.target.value)}
                onBlur={handleNameBlur}
                className="text-sm font-bold border-b text-secondary border-secondary"
              />
            ) : (
              <p className="text-sm font-bold text-secondary">
                {selectedAreaDetails.Name}
              </p>
            )}
            {!isEditName ? (
              <button
                onClick={() => {
                  setIsEditName(true);
                  setOriginalName(selectedAreaDetails.Name);
                  setEditedName(selectedAreaDetails.Name);
                }}
              >
                <i className="ri-edit-fill text-vekin"></i>
              </button>
            ) : (
              <div>
                <button onClick={() => setIsEditName(false)}>
                  <i className="px-1 py-1 mr-1 text-xl text-white rounded-md ri-close-fill bg-danger"></i>
                </button>
                <button
                  onClick={() => {
                    handleAmountBlur();
                  }}
                >
                  <i className="px-1 py-1 text-xl text-white rounded-md ri-check-fill bg-vekin-primary"></i>
                </button>
              </div>
            )}
          </div>

          <div className="inline-flex justify-end">
            {!isEditUnit && !isEditAmount && !isEditDetail ? (
              <button
                onClick={() => {
                  setIsEditUnit(true);
                  setIsEditDetail(true);
                  setIsEditAmount(true);
                }}
                className="mr-2 text-sm font-bold text-secondary"
              >
                <i className="ri-edit-fill text-vekin"></i> {t('site_management.edit')}
              </button>
            ) : (
              <div className="flex gap-2 mr-2">
                <button
                  onClick={() => {
                    setIsEditUnit(false);
                    setIsEditDetail(false);
                    setIsEditAmount(false);
                  }}
                >
                  <i className="px-1 py-1 mr-1 text-xl text-white rounded-md ri-close-fill bg-danger"></i>
                </button>
                <button
                  onClick={() => {
                    handleUnitBlur();
                    handleAmountBlur();
                    handleDetailBlur();
                  }}
                >
                  <i className="px-1 py-1 text-xl text-white rounded-md ri-check-fill bg-vekin"></i>
                </button>
              </div>
            )}
          </div>

          <div className="flex gap-10 my-6">
            <div>
              <img alt="" src={area} className="w-56 h-56 mx-8" />
            </div>

            <div
              className="mx-10 mt-6 ml-14 "
              style={{ width: "calc(100% - 38px)" }}
            >
              <div className="grid content-end grid-cols-3 gap-2">
                <label className="text-base font-semibold text-secondary">
                {t('site_management.detail')} :
                </label>
                {isEditDetail ? (
                  <input
                    type="text"
                    value={editedDetail}
                    onChange={(e) => setEditedDetail(e.target.value)}
                    onBlur={handleDetailBlur}
                    className="p-2 text-base font-bold border rounded-lg text-secondary border-secondary"
                  />
                ) : (
                  <p className="col-span-2 col-start-2 text-base font-normal text-left text-vekin-green100">
                    {selectedAreaDetails.detail}
                  </p>
                )}
              </div>
              <div className="grid content-end grid-cols-3 gap-2 my-1">
                <label className="text-base font-semibold text-secondary">
                {t('site_management.amount')} :
                </label>
                {isEditAmount ? (
                  <input
                    type="text"
                    value={editedAmount}
                    onChange={(e) => setEditedAmount(e.target.value)}
                    onBlur={handleAmountBlur}
                    className="p-2 text-sm font-bold border rounded-lg text-secondary border-secondary"
                  />
                ) : (
                  <p className="col-span-2 col-start-2 text-base font-normal text-vekin-green100">
                    {selectedAreaDetails.amount}
                  </p>
                )}
              </div>
              <div className="grid content-end grid-cols-3 gap-2 my-2">
                <label className="text-base font-semibold text-secondary">
                {t('site_management.unit')} :
                </label>
                {isEditUnit ? (
                  <input
                    type="text"
                    value={editedUnit}
                    onChange={(e) => setEditedUnit(e.target.value)}
                    onBlur={handleUnitBlur}
                    className="p-2 text-sm font-bold border rounded-lg text-secondary border-secondary"
                  />
                ) : (
                  <p className="col-span-2 col-start-2 text-base font-normal text-vekin-green100">
                    {selectedAreaDetails.unit}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BuildingContent;
